import request from 'utils/request';

export default {
  listEmailTemplatesForShipmentInvoices: async (shipmentId) =>
    (await request.get(`/orders/shipments/${shipmentId}/emails`)).results,

  sendShipmentInvoice: async (shipmentId, data) =>
    await request.post(`/orders/shipments/${shipmentId}/send`, data),

  listRefundEmailTemplates: async (groupId, orderNumber) =>
    await request.get(`/orders/by_number/${orderNumber}/refund_templates`, {
      group: groupId,
    }),

  sendRefundEmail: async (groupId, orderNumber, data) =>
    await request.post(
      `/orders/by_number/${orderNumber}/send_email?group=${groupId}`,
      data,
    ),
};
